import React from 'react'
import { Link } from 'react-router-dom'
import { Card, CardBody, Col, Row ,  Media,} from 'reactstrap'
import WelcomeComp from '../../pages/Dashboard/WelcomeComp'

const DashboardForESM = (props) => {

  let OredrCount = props.OrderDetails

  return (
    <>
    <Row>
       <Col md="6">
                      <WelcomeComp />
                    </Col>
                    </Row>
      {/* <Row>
        
        <Col md="4">
          <Link to="/equipments/new_orders">
            <Card className="mini-stats-wid" style={{backgroundColor: "#ffebee",color:"#b71c1c",border:"1px solid #f7766f"}}>
              <CardBody style={{paddingLeft:"0px",paddingRight:"0px",textAlign:"center",height:"100px"}}>
                <Media>
                  <Media body>
                    <p className="fw-medium">
                      Orders
                    </p>
                    <h4
                      className="mb-0"
                      style={{ color: "#b71c1c" }}
                    >
                      {OredrCount &&
                        OredrCount.new_orders || 0}
                    </h4>
                  </Media>
                </Media>
              </CardBody>
            </Card>
          </Link>
        </Col>
        <Col md="4">
          <Link to="/equipments/orders_in_process">
            <Card className="mini-stats-wid" style={{backgroundColor: "#fff8e1",color:"#f57f17",border:"1px solid #f7dc79"}}>
              <CardBody  style={{paddingLeft:"0px",paddingRight:"0px",textAlign:"center",height:"100px"}}> 
                <Media>
                  <Media body>
                    <p className="fw-medium">
                      In Process
                    </p>
                    <h4
                      className="mb-0"
                      style={{ color: "#f57f17" }}
                    >
                      {OredrCount &&
                        OredrCount.in_process_orders || 0}
                    </h4>
                  </Media>
                </Media>
              </CardBody>
            </Card>
          </Link>
        </Col>
        <Col md="4">
          <Link to="/equipments/closed_orders">
            <Card className="mini-stats-wid"  style={{backgroundColor: "#e8f5e9",color:"#1b5e20", border:"1px solid #9dde81"}}>
              <CardBody style={{paddingLeft:"0px",paddingRight:"0px",textAlign:"center",height:"100px"}}>
                <Media>
                  <Media body>
                    <p className="fw-medium">
                      Closed
                    </p>
                    <h4
                      className="mb-0"
                      style={{ color: "#1b5e20" }}
                    >
                      {OredrCount &&
                        OredrCount.closed_orders || 0}
                    </h4>
                  </Media>
                </Media>
              </CardBody>
            </Card>
          </Link>
        </Col>

      </Row> */}
    </>
  )
}

export default DashboardForESM